import React from "react";

interface IProps {
    drawn: boolean;
    numberValue: number;
    selected: boolean;
    onToggle?(value: number): void;
}

export default class GameBoardNumber extends React.Component<IProps> {
    public render(): JSX.Element {
        const { numberValue, onToggle, selected, drawn } = this.props;

        const classes = ["game-board-number"];
        if (selected) {
            classes.push("selected");
        }
        if (drawn) {
            classes.push("drawn");
        }
        if (onToggle) {
            classes.push("clickable");
        }

        const EVEN = 2;
        classes.push(numberValue % EVEN === 0 ? "even" : "odd");

        return (
            <td className={ classes.join(" ") } onClick={ this.handleClick.bind(this) }>
                { numberValue }
            </td>
        );
    }
    protected handleClick(): void {
        const { onToggle, numberValue } = this.props;
        if (onToggle) {
            onToggle(numberValue);
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/GameBoardNumber.tsx